<template>
  <div :class="$style.infoBlock">
    <div v-if="icon" :class="[$style.componentIcon, $style[variant]]">
      <icon
          :icon="icon"
          :class="$style.blockIcon"
      ></icon>
    </div>
    <div :class="$style.content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import icon from "../display/icon"

export default {
  name: "info-block",
  components: { icon },
  props: {
    variant: {
      type: String,
      default: "info",
      validator: function(value) {
        return ["info", "success", "warning", "danger"].indexOf(value) !== -1;
      }
    },
    icon: { type: String }
  }
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.colors.scss";
@import "../../style/abstract/abstract.functions.scss";
@import "../../style/abstract/abstract.spacing.scss";
@import "../../style/abstract/abstract.typography.scss";

.infoBlock {
  display: flex;
  line-height: 1.25;
  position: relative;
  font-size: rem-calc(15);
  font-family: $font-family;
  margin-top: rem-calc($spacing-xl);
  border: rem-calc(1) solid $color-dimgrey;
}

.componentIcon {
  width: rem-calc(75);
  display: flex;
  align-items: center;
  color: $color-dimgrey;
  justify-content: center;
  font-size: rem-calc(27);
  border-right: rem-calc(1) solid $color-dimgrey;

  &.success {
    background-color: $color-success;
  }

  &.info {
    background-color: $color-info;
  }

  &.warning {
    background-color: $color-warning;
  }

  &.danger {
    background-color: $color-attention;
  }
}

.blockIcon {
  top: 50%;
  position: absolute;
  transform: translate(0, -50%);
}

.content {
  width: 100%;
  padding: rem-calc($spacing-l);
}
</style>
